import { useQueryExternalPONumberingSetting } from '@webapp/modules/purchasing/features/get-external-po-numbering-setting/models'

/**
 * Reads the `auto-po-custom-sequence` system preference for the External PO
 * Numbering toggle card's current value. A GET 404 (preference never set)
 * maps to `false` — off, never an error (BHV-004). Called only when the
 * `enable_auto_po` feature switch is on (Feature Set gate).
 */
export const useExternalPONumberingSettingPresenter = () => {
  const { value, isLoading } = useQueryExternalPONumberingSetting()

  return {
    isEnabled: value,
    isLoading,
  }
}
